import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function ThaneToGoaCabs() {



    const cardData = {





keyword: "Thane to Goa Cabs",

headingDescription: "Shreesha Tours & Travels provides comfortable and reliable Thane to Goa Cab Service for families, couples, corporate travelers, groups, and tourists planning a convenient road journey to Goa. We offer a wide range of chauffeur-driven vehicles including Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, and premium cars for one-way and round-trip travel. With experienced drivers, clean vehicles, flexible booking options, transparent pricing, doorstep pickup, and 24/7 customer support, we ensure a safe and enjoyable journey from Thane to Goa. Whether you are planning a beach holiday, family vacation, honeymoon trip, or Goa sightseeing tour, Shreesha Tours & Travels provides dependable cab services with complete comfort.",

topPlaces: [
  {
    title: "Morjim Beach Goa",
    description: "Morjim Beach is a peaceful coastal destination in North Goa known for its clean shoreline, relaxing atmosphere, beach cafés, and beautiful sunset views. It is also famous as a nesting site for Olive Ridley turtles. Travelers looking for a calm beach experience away from crowded locations often prefer Morjim during their Goa holiday."
  },
  {
    title: "Tiracol Fort Goa",
    description: "Tiracol Fort is a historic Portuguese-era fort located in North Goa, offering stunning views of the Arabian Sea and surrounding coastline. The fort's heritage architecture, peaceful surroundings, and scenic location make it a great attraction for history lovers and photographers visiting Goa."
  },
  {
    title: "Arambol Beach Goa",
    description: "Arambol Beach is known for its natural beauty, peaceful environment, beach markets, live music, and relaxed traveller-friendly atmosphere. The beach attracts tourists who enjoy sunset views, local experiences, and a less commercialized side of Goa."
  },
  {
    title: "Salim Ali Bird Sanctuary Goa",
    description: "Salim Ali Bird Sanctuary is a beautiful nature destination located on Chorao Island near Panaji. Surrounded by mangroves, the sanctuary is home to various migratory and local bird species. It is an ideal place for nature lovers, photographers, and travelers interested in wildlife experiences."
  },
  {
    title: "Butterfly Beach Goa",
    description: "Butterfly Beach is a hidden coastal attraction in South Goa famous for clear waters, scenic landscapes, and peaceful surroundings. The beach offers a relaxing experience away from busy tourist areas and is popular among couples and photographers looking for beautiful natural views."
  },
  {
    title: "Cavelossim Beach Goa",
    description: "Cavelossim Beach is a beautiful South Goa destination known for luxury resorts, clean beaches, riverside views, and peaceful surroundings. It is suitable for families and travelers who want a comfortable beach holiday with excellent hospitality and relaxing experiences."
  },
  {
    title: "Nossa Senhora de Imaculada Conception Church Goa",
    description: "This historic church in Panaji is one of Goa's most recognizable heritage landmarks, known for its white architecture, grand staircase, and Portuguese influence. The church attracts visitors interested in history, culture, photography, and Goa's colonial heritage."
  },
  {
    title: "Chorla Ghat Goa",
    description: "Chorla Ghat is a scenic natural destination located near Goa, Karnataka, and Maharashtra borders. Known for lush greenery, waterfalls, forests, and wildlife, it is perfect for nature lovers and travelers seeking a peaceful getaway surrounded by hills."
  },
  {
    title: "Betalbatim Beach Goa",
    description: "Betalbatim Beach is a quiet South Goa beach famous for its golden sand, peaceful atmosphere, and beautiful sunsets. It is an excellent destination for travelers who want a relaxing beach experience away from crowded tourist spots."
  },
  {
    title: "Grande Island Goa",
    description: "Grande Island is a popular adventure destination near Goa known for snorkeling, scuba diving, dolphin spotting, and underwater experiences. It attracts adventure enthusiasts looking for exciting marine activities and memorable moments during their Goa trip."
  }
],


"services": [
  {
    "name": "Thane to Goa Cabs",
    "description": "Book Thane to Goa Cabs for comfortable and reliable long-distance travel with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova, Innova Crysta, SUV, Kia Carens, and luxury cabs for family trips, vacations, corporate travel, and one-way journeys."
  },
  {
    "name": "Thane to Goa Cab Service",
    "description": "Choose Thane to Goa Cab Service for safe and affordable outstation travel with experienced drivers, clean vehicles, and flexible booking options. Enjoy smooth highway travel with doorstep pickup and comfortable rides."
  },
  {
    "name": "Thane to Goa Taxi Service",
    "description": "Reserve Thane to Goa Taxi Service for convenient private transportation with professional chauffeurs and premium AC taxis. Perfect for tourists, families, business travelers, and weekend trips."
  },
  {
    "name": "Thane to Goa Cab Booking",
    "description": "Complete Thane to Goa Cab Booking online for quick confirmation, transparent pricing, and multiple vehicle options. Select your preferred cab for a comfortable journey from Thane to Goa."
  },
  {
    "name": "Thane to Goa One Way Cab",
    "description": "Book Thane to Goa One Way Cab for direct drop taxi service without return charges. Enjoy affordable fares, flexible pickup timings, and comfortable travel with experienced drivers."
  },
  {
    "name": "Thane to Goa Outstation Cab",
    "description": "Hire Thane to Goa Outstation Cab for reliable interstate travel with spacious AC vehicles and trained chauffeurs. Ideal for family vacations, corporate trips, and private Goa tours."
  },
  {
    "name": "Thane to Goa Innova Cab",
    "description": "Reserve Thane to Goa Innova Cab for spacious and comfortable travel with premium seating, luggage space, and smooth rides for families and groups."
  },
  {
    "name": "Thane to Goa Innova Crysta Cab",
    "description": "Choose Thane to Goa Innova Crysta Cab for luxury outstation travel with premium interiors, comfortable seating, and experienced chauffeurs for a relaxed journey."
  },
  {
    "name": "Thane to Goa Ertiga Cab",
    "description": "Book Thane to Goa Ertiga Cab for affordable family transportation with spacious seating, clean AC vehicles, and reliable chauffeur-driven service."
  },
  {
    "name": "Thane to Goa Luxury Cab",
    "description": "Hire Thane to Goa Luxury Cab for premium travel with high-comfort vehicles and professional drivers. Perfect for VIP travel, corporate journeys, and special occasions."
  },
  {
    "name": "Thane to Goa AC Taxi Service",
    "description": "Reserve Thane to Goa AC Taxi Service for comfortable travel in air-conditioned vehicles with skilled drivers and reliable long-distance transportation."
  },
  {
    "name": "Ghodbunder to Goa Cab Service",
    "description": "Book Ghodbunder to Goa Cab Service for convenient outstation travel with doorstep pickup, experienced chauffeurs, and comfortable AC vehicles."
  },
  {
    "name": "Ghodbunder Road to Goa Cabs",
    "description": "Choose Ghodbunder Road to Goa Cabs for safe and affordable journeys with multiple vehicle options including Sedan, SUV, Innova, and premium cabs."
  },
  {
    "name": "Ghodbunder to Goa Taxi",
    "description": "Reserve Ghodbunder to Goa Taxi for private travel with professional drivers, clean vehicles, and reliable service for vacations and business trips."
  },
  {
    "name": "Ghodbunder to Goa One Way Cab",
    "description": "Book Ghodbunder to Goa One Way Cab for economical drop taxi service with direct travel and no return charges. Enjoy smooth and comfortable rides."
  },
  {
    "name": "Ghodbunder to Goa Outstation Cab",
    "description": "Hire Ghodbunder to Goa Outstation Cab for long-distance travel with experienced chauffeurs and premium AC vehicles suitable for families and groups."
  },
  {
    "name": "Ghodbunder to Goa Cab Booking",
    "description": "Complete Ghodbunder to Goa Cab Booking online with easy reservations, affordable fares, and reliable vehicle options for your Goa journey."
  },
  {
    "name": "Ghodbunder to Goa Innova Cab",
    "description": "Book Ghodbunder to Goa Innova Cab for spacious travel with comfortable seating, luggage capacity, and smooth highway rides."
  },
  {
    "name": "Ghodbunder to Goa Ertiga Cab",
    "description": "Choose Ghodbunder to Goa Ertiga Cab for family-friendly travel with affordable pricing, clean vehicles, and professional drivers."
  },
  {
    "name": "Kalyan Dombivli to Goa Cabs",
    "description": "Reserve Kalyan Dombivli to Goa Cabs for comfortable outstation journeys with reliable chauffeurs and multiple cab choices for families and groups."
  },
  {
    "name": "Kalyan to Goa Cab Service",
    "description": "Book Kalyan to Goa Cab Service for safe and convenient travel with experienced drivers, AC vehicles, and affordable pricing."
  },
  {
    "name": "Dombivli to Goa Taxi Service",
    "description": "Choose Dombivli to Goa Taxi Service for dependable private transportation with comfortable vehicles and professional chauffeur support."
  },
  {
    "name": "Kalyan to Goa Cab Booking",
    "description": "Book Kalyan to Goa Cab Booking online for quick reservations with transparent fares and multiple vehicle categories."
  },
  {
    "name": "Dombivli to Goa One Way Cab",
    "description": "Hire Dombivli to Goa One Way Cab for direct drop service with flexible pickup and affordable travel options."
  },
  {
    "name": "Kalyan Dombivli to Goa Outstation Cab",
    "description": "Reserve Kalyan Dombivli to Goa Outstation Cab for comfortable interstate travel with experienced drivers and premium vehicles."
  },
  {
    "name": "Kalyan to Goa Innova Crysta",
    "description": "Book Kalyan to Goa Innova Crysta for luxury family travel with premium comfort, spacious interiors, and smooth rides."
  },
  {
    "name": "Dombivli to Goa Sedan Cab",
    "description": "Choose Dombivli to Goa Sedan Cab for economical and comfortable travel with clean AC sedan cars and professional chauffeurs."
  },
  {
    "name": "Kalyan to Goa Luxury Taxi",
    "description": "Hire Kalyan to Goa Luxury Taxi for premium journeys with luxury vehicles, experienced drivers, and superior comfort."
  },
  {
    "name": "Kalyan Dombivli to Goa AC Cab",
    "description": "Reserve Kalyan Dombivli to Goa AC Cab for relaxing travel with air-conditioned vehicles and reliable chauffeur service."
  },
  {
    "name": "Bhiwandi to Goa Cabs",
    "description": "Book Bhiwandi to Goa Cabs for affordable and comfortable travel with professional drivers and well-maintained vehicles."
  },
  {
    "name": "Bhiwandi to Goa Cab Service",
    "description": "Choose Bhiwandi to Goa Cab Service for reliable outstation transportation with flexible booking and premium vehicle options."
  },
  {
    "name": "Bhiwandi to Goa Taxi",
    "description": "Reserve Bhiwandi to Goa Taxi for private travel with experienced chauffeurs and comfortable AC vehicles."
  },
  {
    "name": "Bhiwandi to Goa One Way Cab",
    "description": "Book Bhiwandi to Goa One Way Cab for direct drop taxi service with affordable pricing and no return charges."
  },
  {
    "name": "Bhiwandi to Goa Cab Booking",
    "description": "Complete Bhiwandi to Goa Cab Booking online for convenient reservations and reliable travel services."
  },
  {
    "name": "Bhiwandi to Goa Outstation Taxi",
    "description": "Hire Bhiwandi to Goa Outstation Taxi for safe long-distance travel with professional drivers and comfortable vehicles."
  },
  {
    "name": "Bhiwandi to Goa Innova Cab",
    "description": "Choose Bhiwandi to Goa Innova Cab for spacious group travel with premium comfort and luggage space."
  },
  {
    "name": "Bhiwandi to Goa Ertiga Cab",
    "description": "Book Bhiwandi to Goa Ertiga Cab for affordable family travel with comfortable seating and reliable service."
  },
  {
    "name": "Palghar to Goa Cab Service",
    "description": "Reserve Palghar to Goa Cab Service for comfortable outstation travel with experienced chauffeurs and quality AC vehicles."
  },
  {
    "name": "Palghar to Goa Cabs",
    "description": "Book Palghar to Goa Cabs for safe and affordable journeys with multiple cab options for families and groups."
  },
  {
    "name": "Palghar to Goa Taxi Service",
    "description": "Choose Palghar to Goa Taxi Service for reliable private transportation with clean vehicles and professional drivers."
  },
  {
    "name": "Palghar to Goa Cab Booking",
    "description": "Book Palghar to Goa Cab Booking for easy reservations, transparent pricing, and comfortable travel options."
  },
  {
    "name": "Palghar to Goa One Way Cab",
    "description": "Hire Palghar to Goa One Way Cab for direct drop service with affordable fares and convenient pickup."
  },
  {
    "name": "Palghar to Goa Outstation Cab",
    "description": "Reserve Palghar to Goa Outstation Cab for long-distance travel with premium vehicles and experienced chauffeurs."
  },
  {
    "name": "Palghar to Goa Innova Crysta",
    "description": "Book Palghar to Goa Innova Crysta for premium comfort, spacious interiors, and luxury travel experience."
  },
  {
    "name": "Palghar to Goa Sedan Cab",
    "description": "Choose Palghar to Goa Sedan Cab for budget-friendly travel with clean AC cars and professional drivers."
  },
  {
    "name": "Boisar to Goa Cabs Service",
    "description": "Book Boisar to Goa Cabs Service for reliable outstation travel with comfortable vehicles and experienced chauffeurs."
  },
  {
    "name": "Boisar to Goa Cab Booking",
    "description": "Reserve Boisar to Goa Cab Booking online for quick confirmation and affordable travel solutions."
  },
  {
    "name": "Boisar to Goa Taxi Service",
    "description": "Choose Boisar to Goa Taxi Service for safe and comfortable travel with professional drivers."
  },
  {
    "name": "Vasai to Goa Cabs Service",
    "description": "Book Vasai to Goa Cabs Service for convenient interstate travel with clean AC vehicles and reliable chauffeurs."
  },
  {
    "name": "Vasai to Goa Cab Booking",
    "description": "Reserve Vasai to Goa Cab Booking for easy online reservations and multiple vehicle options."
  },
  {
    "name": "Vasai to Goa Taxi Service",
    "description": "Choose Vasai to Goa Taxi Service for comfortable private travel with experienced drivers and affordable fares."
  },
  {
    "name": "Vasai to Goa One Way Cab",
    "description": "Hire Vasai to Goa One Way Cab for direct drop service with flexible booking and comfortable travel."
  },
  {
    "name": "Vasai to Goa Outstation Taxi",
    "description": "Book Vasai to Goa Outstation Taxi for reliable long-distance journeys with premium vehicles and professional chauffeurs."
  },
  {
    "name": "Vasai Virar to Goa Cab",
    "description": "Reserve Vasai Virar to Goa Cab for safe and comfortable travel with family, corporate, and tourist travel options."
  },
  {
    "name": "Vasai to Goa Innova Cab",
    "description": "Choose Vasai to Goa Innova Cab for spacious and comfortable rides with premium seating and luggage capacity."
  },
  {
    "name": "Vasai to Goa Ertiga Cab",
    "description": "Book Vasai to Goa Ertiga Cab for affordable family trips with clean vehicles and professional drivers."
  }
],
"tableData": [
  ["Thane to Goa Cabs", "Thane to Goa Cab Service"],
  ["Thane to Goa Taxi Service", "Thane to Goa Cab Booking"],
  ["Thane to Goa One Way Cab", "Thane to Goa Outstation Cab"],
  ["Ghodbunder to Goa Cab Service", "Ghodbunder Road to Goa Cabs"],
  ["Ghodbunder to Goa Taxi", "Ghodbunder to Goa One Way Cab"],
  ["Kalyan Dombivli to Goa Cabs", "Kalyan to Goa Cab Service"],
  ["Dombivli to Goa Taxi Service", "Kalyan to Goa Cab Booking"],
  ["Bhiwandi to Goa Cabs", "Bhiwandi to Goa Cab Service"],
  ["Palghar to Goa Cab Service", "Palghar to Goa Cabs"],
  ["Boisar to Goa Cabs Service", "Vasai to Goa Cabs Service"],
  ["Vasai to Goa Cab Booking", "Vasai Virar to Goa Cab"]
],



whychoose: [
  {
    WhyChooseheading: "Thane to Goa Cab Service for Comfortable Road Trips",
    WhyChoosedescription: "Shreesha Travels provides private Thane to Goa cabs for travellers looking for a comfortable and convenient journey. Whether it is a family holiday, weekend escape, business visit, or group trip, our chauffeur-driven vehicles make your Goa travel smooth and relaxing."
  },
  {
    WhyChooseheading: "Direct Pickup from Thane to Goa Destination",
    WhyChoosedescription: "Travel from your preferred location in Thane directly to Goa hotels, resorts, beaches, villas, and tourist areas with doorstep pickup and drop facilities. Avoid the inconvenience of multiple transport changes."
  },
  {
    WhyChooseheading: "Cars Available for Small & Large Groups",
    WhyChooseheading: "Cars Available for Small & Large Groups",
    WhyChoosedescription: "Select a suitable vehicle from Sedan Cars, Swift Dzire, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium cars based on your passengers and luggage."
  },
  {
    WhyChooseheading: "One Way & Round Trip Goa Travel Options",
    WhyChoosedescription: "Plan your journey according to your requirement with one-way Thane to Goa taxi service or round-trip cab packages with flexible return schedules and customized travel plans."
  },
  {
    WhyChooseheading: "Perfect for Goa Holidays & Special Trips",
    WhyChoosedescription: "Our Thane to Goa taxi service is suitable for beach vacations, family tours, honeymoon travel, destination weddings, corporate outings, and sightseeing plans across Goa."
  },
  {
    WhyChooseheading: "Experienced Chauffeurs for Long Distance Routes",
    WhyChoosedescription: "Professional drivers with highway experience ensure safe travel, timely departure, smooth route handling, and a comfortable journey throughout the Thane to Goa route."
  },
  {
    WhyChooseheading: "Well-Maintained Vehicles for Safe Travel",
    WhyChoosedescription: "Every cab is cleaned, serviced, air-conditioned, and inspected before the trip to provide a hygienic and enjoyable travel experience for passengers."
  },
  {
    WhyChooseheading: "Choose Shreesha Travels for Thane to Goa Cabs",
    WhyChoosedescription: "Get dependable transportation, transparent pricing, quick booking support, and comfortable chauffeur-driven cars for your Thane to Goa travel needs."
  }
]

};

const faqData = [
  {
    question: "Can I book a cab from Thane to Goa?",
    answer: "Yes, private cabs are available from Thane to Goa for comfortable and direct travel."
  },
  {
    question: "Do you offer one way Thane to Goa taxi service?",
    answer: "Yes, one-way cab options are available for travellers who need direct transportation to Goa."
  },
  {
    question: "Can I reserve a round trip cab from Thane to Goa?",
    answer: "Yes, round-trip packages are available with flexible return dates and customized travel plans."
  },
  {
    question: "Which vehicles are available for Thane to Goa travel?",
    answer: "Available vehicles include Sedan Cars, Swift Dzire, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium cars."
  },
  {
    question: "Is Thane to Goa cab service suitable for family trips?",
    answer: "Yes, comfortable vehicles are available for families, couples, senior citizens, and groups travelling to Goa."
  },
  {
    question: "Can I book pickup from Thane railway station or hotel?",
    answer: "Yes, pickup can be arranged from homes, hotels, offices, railway stations, and other preferred locations in Thane."
  },
  {
    question: "Can I add sightseeing stops during the Goa trip?",
    answer: "Yes, additional stops and customized sightseeing plans can be included based on your travel requirements."
  },
  {
    question: "How is Thane to Goa cab fare calculated?",
    answer: "The fare depends on vehicle selection, distance, route, toll charges, parking fees, trip type, and additional requirements."
  },
  {
    question: "Are overnight cabs available from Thane to Goa?",
    answer: "Yes, cab bookings can be scheduled for overnight travel according to your preferred departure time."
  },
  {
    question: "How can I book Thane to Goa Cabs with Shreesha Travels?",
    answer: "Share your pickup location, travel date, passenger count, destination in Goa, and preferred vehicle to receive a customized quotation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kunal Shah",
    feedback: "The Thane to Goa cab service was comfortable and reliable. The driver managed the route well, and the vehicle was perfect for our family journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Naik",
    feedback: "A great travel experience for our Goa vacation. The cab arrived on schedule, the chauffeur was courteous, and the entire ride was smooth.",
    rating: 5
  }
];




    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Thane to Goa Cabs",
  "image": "https://www.shreeshatravels.com/assets/images/thane-to-goa-cabs.webp",
  "description":
    "Book Thane to Goa Cabs with Shreesha Tours & Travels for comfortable and reliable outstation taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for Goa trips, family vacations, sightseeing tours, one-way journeys, round trips, and long-distance travel from Thane to Goa with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/thane-to-goa-cabs"
  }
};








    return (
        <div>
<Helmet>
  <title>Thane to Goa Cabs | Goa Taxi Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Thane to Goa Cabs with Shreesha Travels for safe and comfortable outstation taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for Goa trips, one-way cab, round trips, family travel, sightseeing tours, and 24x7 cab booking from Thane to Goa."
  />

  <meta
    name="keywords"
    content="Thane to Goa Cabs, Thane to Goa Cab Service, Thane to Goa Taxi Service, Thane to Goa Cab Booking, Thane to Goa One Way Cab, Thane to Goa Outstation Cab, Thane Goa Taxi, Thane Goa Car Rental, Thane to Goa Private Cab, Goa Tour Cab from Thane, Thane Goa Round Trip Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/115.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default ThaneToGoaCabs;